const NAMESPACE = "projectFormTable";

const KEYS = {
    formsLabel: "formsLabel",
    selectedFormLabelLayout: "selectedFormLabelLayout",
    availableFormsLabel: "availableFormsLabel",
    previousFormsLabel: "previousFormsLabel",
    adminFormsLabel: "adminFormsLabel",
    beginFormButtonLabel: "beginFormButtonLabel",
    continueFormButtomLabel: "continueFormButtomLabel",
    editFormButtonLabel: "editFormButtonLabel",
    viewFormButtonLabel: "viewFormButtonLabel",
    noDataFormText: "noDataFormText",
    tableDescriptionColumnHeader: "tableDescriptionColumnHeader",
    tableStatusColumnHeader: "tableStatusColumnHeader",
    emptyFormsTableText: "emptyFormsTableText",
    emptyAvailableFormsTableText: "emptyAvailableFormsTableText",
    emptySubmittedFormsTableText: "emptySubmittedFormsTableText",
    firstSubmittedFormMessage: "firstSubmittedFormMessage"
};

const MESSAGES = {
    [KEYS.formsLabel]: {
        value: "Forms",
        comment: "Label for Forms capsule header"
    },
    [KEYS.selectedFormLabelLayout]: {
        value: "{formsLabel} - {formDescription}",
        comment: "Label for Forms capsule header when a form is selected"
    },
    [KEYS.availableFormsLabel]: {
        value: "Current Forms",
        comment: "Label for Available Forms table header"
    },
    [KEYS.previousFormsLabel]: {
        value: "Previously Submitted Forms",
        comment: "Label for Previous Forms table header"
    },
    [KEYS.adminFormsLabel]: {
        value: "Administrative Forms",
        comment: "Label for Admin Forms table header"
    },
    [KEYS.beginFormButtonLabel]: {
        value: "Begin",
        comment:
            "Button label that allows user to begin editing a new form related to the row in the project " +
            "form table."
    },
    [KEYS.continueFormButtomLabel]: {
        value: "Continue",
        comment:
            "Button label that allows user to resume editing the new form related to the row in the project " +
            "form table."
    },
    [KEYS.editFormButtonLabel]: {
        value: "Edit",
        comment:
            "Button label that allows user to continue editing an existing form related to the row in the " +
            "project form table."
    },
    [KEYS.viewFormButtonLabel]: {
        value: "View",
        comment:
            "Button label that allows user to view a read-only version of the form related to the row in the " +
            "project form table."
    },
    [KEYS.noDataFormText]: {
        value: "No Data",
        comment:
            "Text that appears when a new read-only form has become available but has no data and cannot yet be viewed."
    },
    [KEYS.tableDescriptionColumnHeader]: {
        value: "Form Name",
        comment: "Header for the column that displays the form name in a project form table."
    },
    [KEYS.tableStatusColumnHeader]: {
        value: "Form Status",
        comment: "Header for the column that displays the form status in a project form table."
    },
    [KEYS.emptyFormsTableText]: {
        value: "There are no forms available.",
        comment: "Text that appears in the forms table when the list of forms is empty."
    },
    [KEYS.emptyAvailableFormsTableText]: {
        value: "There are no forms available during this status.",
        comment: "Text that appears in the available forms table when the list of available forms is empty."
    },
    [KEYS.emptySubmittedFormsTableText]: {
        value: "There are no previously submitted forms.",
        comment: "Text that appears in the submitted forms table when the list of submitted forms is empty."
    },
    [KEYS.firstSubmittedFormMessage]: {
        value: "First submitted form for the project",
        comment: "Value displayed as tooltip in forms table to denote the first submitted form"
    }
};

export { KEYS, NAMESPACE, MESSAGES };
